import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Home from "../Pages/Home/Home";
import Upcoming from "../Pages/Construction/Upcoming";
import InterriorSection from "../Pages/Interior Design/InterriorSection";
import AboutUs from "../Pages/AboutUs/AboutUs";
import ContactInquirey from "../Pages/Contact&Inquirey/Contact&InquireySection";
import Realestate from "../Pages/Realestate/Realestate";
import PropertyDetails from "../Pages/Realestate/PropertyDetails";
import PdfViewer from "../Pages/Realestate/PdfViewer";
import DisclaimerPage from "../Pages/Realestate/DisclaimerPage";
import ProjectsSection from "../Pages/Projects/ProjectsSection";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const PageRoutes = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/construction" element={<Upcoming />} />
        <Route path="/interior-design" element={<InterriorSection />} />
        <Route path="/contact" element={<ContactInquirey />} />
        <Route path="/realestate" element={<Realestate />} />
        <Route path="/propertydetails" element={<PropertyDetails />} />
        <Route path="/propertydetails/:id" element={<PropertyDetails />} />
        <Route path="/pdf-viewer" element={<PdfViewer />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
        <Route path="/projects" element={<ProjectsSection />} />
      </Routes>
    </Router>
  );
};

export default PageRoutes;
